import { listaTitulosAbertosParceirosStyles } from './ListaTitulosParceiros.styles'

export function listaTitulosParceirosIO() {
  return {
    styles: listaTitulosAbertosParceirosStyles
  }
}
export type ListaTitulosParceirosIO = ReturnType<typeof listaTitulosParceirosIO>
